import {
  projectPage,
  examClassificationPage
} from "./api"
export const projectMoudel = {
  data() {
    return {
      projectData: []
    }
  },
  created() {
    this.getprojectPage()
  },
  methods: {
    async getprojectPage() {
      const res = await projectPage({
        page: 1,
        limit: -1,
        status:1
      })
      this.projectData = res.data.records
    },
  }
}

// 习题分类模块 
export const typeMoudel = {
  data() {
    return {
      typeData: []
    }
  },
  created() {
    this.examClassificationPage()
  },
  methods: {
    async examClassificationPage() {
      const res = await examClassificationPage({
        page: 1,
        limit: -1,
        publishStatus:2
      })
      this.typeData = res.data.records
    },
  }
}